import {has} from 'lodash';
import type {JSONNode} from '@packages/shared/types/JSONNode';
/**
 * This function updates a jsonNode Video type by nesting its video-related properties
 * into data.video
 *
 * **Warning**
 * This function is pure and cannot be used as is in the context of jsonNode
 * migrations.
 */
export const migrateJsonNodeVideoData = (jsonNode: JSONNode) => {
  const {type, data = {}, v} = jsonNode;

  if (type !== 'Video') {
    return jsonNode;
  }

  const hasMigrated = has(data, ['video', 'embed']);

  if (hasMigrated) {
    return jsonNode;
  }

  const {embed, style = {}, value, ...restData} = data;
  const {'padding-top': paddingTop, ...restStyle} = style;

  return {
    ...jsonNode,
    data: {
      ...restData,
      // Eg for local styles

      ...(Object.keys(restStyle).length !== 0 ? {style: restStyle} : null),
      video: {
        embed,
        style: {'padding-top': paddingTop},
        value: value || v,
      },
    },
  };
};
